// ScrollContainer.js - 基类组件
import React from 'react';
import { withRouter } from 'react-router-dom'
import ConvoyMenu from './ConvoyMenu'
import LazyImage from './components/lazyImage.jsx';
import Header from './components/header.jsx';
import Footer from './components/footer.jsx';

class ProjectAu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentTab: 0
        };


    }

    componentDidMount() {



    }

    onToggleTab = (value) => {
        this.setState({ currentTab: value })
    }

    render() {

        return (
            <div className={`flex-col`}>
                <Header activeMenu='9' />
                <div className='dv_project_body'>
                    <ConvoyMenu activeMenu={5} />
                    <div className='dv_project_body_right'>
                        <div className={`flex-col`}>
                            <div className='dv_banner_wrap'><img src={require("./assets/img/convoy/55_000012.jpg")} /></div>
                            <div className='dv_contentbodyEs_wrap'>
                                <div className='dv_trake_change flex-row between'>
                                    <div className={this.state.currentTab == 0 ? 'tab selected' : 'tab clickable'} onClick={() => this.onToggleTab(0)}>A1. 校内语言团培</div>
                                    <div className={this.state.currentTab == 1 ? 'tab selected' : 'tab clickable'} onClick={() => this.onToggleTab(1)}>A2. 大学雅思和美研</div>
                                </div>
                                {this.state.currentTab == 0 && <div className='dv_lazy_body flex-col'>
                                    <div className='flex-col'>
                                        <LazyImage imgUrl={require("./assets/img/convoy/55_000013.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/convoy/55_000014.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/convoy/55_000015.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/convoy/55_000016.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/convoy/55_000017.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/convoy/55_000018.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/convoy/55_000055.jpg")} />

                                    </div>

                                </div>}
                                {this.state.currentTab == 1 && <div className='dv_lazy_body flex-col'>
                                    <div className='flex-col'>
                                        <LazyImage imgUrl={require("./assets/img/convoy/55_000019.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/convoy/55_000020.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/convoy/55_000021.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/convoy/55_000022.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/convoy/55_000023.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/convoy/55_000024.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/convoy/55_000055.jpg")} />
                                    </div>
                                </div>}
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>

        );
    }
}

export default withRouter(ProjectAu);